import { ApolloProvider } from '@apollo/client';
import { RouterProvider } from 'react-router-dom';
import { VechaiProvider, extendTheme } from '@vechaiui/react';

import client from '#/utils/apollo-client';
import router from '#/router';
import { LocalizationProvider } from '#/utils/l10n';
import { moveColorScheme } from '#/themes';

const theme = extendTheme({ colorSchemes: { move: moveColorScheme } });

function App() {
  return (
    <LocalizationProvider locales={navigator.languages as string[]}>
      <ApolloProvider client={client}>
        <VechaiProvider theme={theme} colorScheme="move">
          <RouterProvider router={router} />
        </VechaiProvider>
      </ApolloProvider>
    </LocalizationProvider>
  );
}

export default App;
